import { z } from 'zod';
import { helpdeskSearchSchema } from './search';

/** A canonical customer UUID narrows only navigation context; it never authorizes a read. */
export const helpdeskDetailSearchSchema = helpdeskSearchSchema.extend({
  helpdeskCustomerId: z.uuid().optional(),
  helpdeskTab: z.enum(['overview', 'conversation']).optional(),
  helpdeskReplyPage: z.coerce.number().int().min(1).max(100000).optional(),
  helpdeskReplyPageSize: z.coerce.number().int().min(1).max(100).optional(),
});
export type HelpdeskDetailSearch = z.infer<typeof helpdeskDetailSearchSchema>;

export function getHelpdeskListReturnSearch(search: HelpdeskDetailSearch) {
  return helpdeskSearchSchema.parse(search);
}

/** Only a local Helpdesk detail can be a profile return destination. */
export function normalizeHelpdeskDetailReturnTo(value: string | undefined): string | undefined {
  if (value === undefined) return undefined;
  const withoutHash = value.split('#')[0] ?? '';
  const pathname = withoutHash.split('?')[0] ?? '';
  return /^\/(en|ru)\/crm\/helpdesk\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/iu.test(
    pathname
  )
    ? withoutHash
    : undefined;
}
